import axios from 'axios'
import store from '../store/index'
import {APP} from '@/localSettings'

import getToken from '@/managers/getToken'
import env from '@/mixins/env'

export default {
  methods: {
    request (method, url, data) {
      if (APP === 'consignment-portal') {
        let token = window.$cookies.get('va-token')
        let refresh = window.$cookies.get('va-refresh-token')

        if (token !== undefined && token !== null) {
          store.state.token = token
        }

        if (refresh !== undefined && refresh !== null) {
          store.state.refreshToken = refresh
        }

        // url += '&' + env.params()
      }

      if (method === 'get' || method === 'download') {
        return new Promise((resolve, reject) => {
          getToken(store.state.token, store.state.refreshToken).then(response => {
            axios({
              method: method,
              url: env.api_url() + url,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + response
              },
              params: data
            }).then((response) => {
              if (response.status === 200) {
                let data = response.data

                for (let key of Object.keys(data)) {
                  if (data[key] === 'None') {
                    data[key] = ''
                  }
                }

                resolve(response.data)
              } else {
                resolve(false)
              }
            }).catch(error => {
              reject(error.response.data)
            })
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          getToken(store.state.token, store.state.refreshToken).then(response => {
            axios({
              method: method,
              url: env.api_url() + url,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + response
              },
              data: data
            }).then((response) => {
              if (response.status === 200 || response.status === 201) {
                resolve(response.data)
              } else {
                resolve(false)
              }
            }).catch(error => {
              reject(error.response.data)
            })
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/client.js